import React from 'react'

const Footer = (props) => {
    return (
        <footer
            style={{
                textAlign: 'center'
            }}
        >
            <a
                style={{
                    textDecoration:'none',
                    color:'currentcolor'
                }}
                id="bollo"
                href="https://codific.ar"
                target="_blank"
                rel="noreferrer"
            >
                Copyright 2025
                <img
                    src="https://codific.ar/wp-content/uploads/2023/10/cropped-favicon-2-32x32.png"
                    alt="Logo desarrollador Web"
                />
                Codific.ar
            </a>
        </footer>
    );
}
export default Footer;
